import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { CompanyData } from '../../../company/types/company-data';

export abstract class MdrCustomerPanelBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getMyCompanyData(): Promise<CompanyData>;
}
